export const parseAndReplaceStepper = (value) => {
    if (value ) {

      return parseFloat(value.toString().replace('.', ''));
    }
    return undefined;
  };